<template>
  <!-- Loading -->
  <div class="vld-parent">
    <loading
      v-model:active="isLoading"
      :is-full-page="true"
      :height="128"
      :width="128"
    />
  </div>
  <!-- Form -->
  <form @submit.prevent="store" class="form-content">
    <div class="form-content-inner">
      <div class="form-content-list">
        <control
          type="hidden"
          v-model="punishmentTransaction.id"
          :hasError="!!errors.id"
          id="id"
        />
        <!-- <div class="form-col">
        <field
          :label="$t('punishmentTransaction.school')"
          class="w-full md:ml-2 mb-2 md:mb-0"
          :hasError="errors.school_id"
        >
          <control
            :options="schoolList"
            :placeholder="$t('punishmentTransaction.placeholder.school')"
            v-model="punishmentTransaction.school_id"
            id="school_id"
            :hasError="!!errors.school_id"
            required
          />
        </field>
      </div>

      <div class="form-col">
        <field
          :label="$t('punishmentTransaction.branch')"
          class="w-full md:ml-2 mb-2 md:mb-0"
          :hasError="errors.branch_id"
        >
          <control
            :options="branchList"
            :placeholder="$t('punishmentTransaction.placeholder.branch')"
            v-model="punishmentTransaction.branch_id"
            id="branch_id"
            :hasError="!!errors.branch_id"
            required
          />
        </field>
      </div> -->
        <!-- showEdit {{ showEdit }} -->
        <div class="form-col">
          <field
            :label="$t('punishmentTransaction.number')"
            class="w-full md:w-2/2 px-3 mb-6 md:mb-0"
            :hasError="errors.number"
          >
            <control
              type="text"
              :placeholder="$t('punishmentTransaction.placeholder.number')"
              v-model="punishmentTransaction.number"
              :hasError="!!errors.number"
              id="number"
              disabled="disabled"
            />
          </field>
        </div>

        <div class="form-col">
          <field
            :label="$t('punishmentTransaction.employee')"
            class="w-full md:w-2/2 px-3 mb-6 md:mb-0"
            :hasError="errors.employee_id"
          >
            <control
              :options="employeeList"
              :placeholder="$t('punishmentTransaction.placeholder.employee')"
              v-model="punishmentTransaction.employee_id"
              id="employee_id"
              :hasError="!!errors.employee_id"
              required
            />
          </field>
        </div>

        <div class="form-col">
          <field
            :label="$t('punishmentTransaction.violation')"
            class="w-full md:w-2/2 px-3 mb-6 md:mb-0"
            :hasError="errors.violation_id"
          >
            <control
              :options="violationList"
              :placeholder="$t('punishmentTransaction.placeholder.violation')"
              v-model="punishmentTransaction.violation_id"
              id="violation_id"
              :hasError="!!errors.violation_id"
              required
            />
          </field>
        </div>

        <div class="form-col">
          <field
            :label="$t('punishmentTransaction.punishment')"
            class="w-full md:w-2/2 px-3 mb-6 md:mb-0"
            :hasError="errors.punishment_id"
          >
            <control
              :options="violationConsequenciesListFilter"
              :placeholder="$t('punishmentTransaction.placeholder.punishment')"
              v-model="punishmentTransaction.punishment_id"
              id="punishment_id"
              :hasError="!!errors.punishment_id"
              required
              @change="handleDateChange(punishmentTransaction, $event)"
            />
          </field>
        </div>

        <div class="form-col">
          <field
            :label="$t('punishmentTransaction.transaction_date')"
            class="w-full md:w-2/2 px-3 mb-6 md:mb-0"
            :hasError="errors.transaction_date"
          >
            <!-- <control
            type="date"
            :placeholder="
              $t('punishmentTransaction.placeholder.transaction_date')
            "
            v-model="punishmentTransaction.transaction_date"
            :hasError="!!errors.transaction_date"
            id="transaction_date"
            @change="handleDateChange(punishmentTransaction, $event)"
          /> -->
            <datepicker
              v-model="punishmentTransaction.transaction_date"
              :placeholder="
                $t('punishmentTransaction.placeholder.transaction_date')
              "
              :enableTimePicker="false"
              name="transaction_date"
              :auto-apply="true"
              @update:model-value="
                handleDateChange(punishmentTransaction, $event)
              "
            >
            </datepicker>
          </field>
        </div>
        <div class="form-col" v-show="showExpiredDate">
          <field
            :label="'Expired Date'"
            class="w-full md:w-2/2 px-3 mb-1 md:mb-0"
          >
            <datepicker
              v-model="punishmentTransaction.expired_date"
              :placeholder="
                $t('punishmentTransaction.placeholder.expired_date')
              "
              :enableTimePicker="false"
              name="expired_date"
              :auto-apply="true"
            >
            </datepicker>
            <!-- <control
            type="date"
            :placeholder="$t('punishmentTransaction.placeholder.expired_date')"
            v-model="punishmentTransaction.expired_date"
            :hasError="!!errors.expired_date"
            id="expired_date"
          /> -->
          </field>
        </div>
        <div class="form-col">
          <field
            :label="$t('punishmentTransaction.remarks')"
            class="w-full md:w-2/2 px-3 mb-6 md:mb-0"
            :hasError="errors.remarks"
          >
            <control
              type="textarea"
              :placeholder="$t('punishmentTransaction.placeholder.remarks')"
              v-model="punishmentTransaction.remarks"
              :hasError="!!errors.remarks"
              id="remarks"
            />
          </field>
        </div>

        <div class="form-col">
          <field
            :label="$t('punishmentTransaction.proposed_by')"
            class="w-full md:w-2/2 px-3 mb-6 md:mb-0"
            :hasError="errors.proposed_by_id"
          >
            <control
              :options="employeeList"
              :placeholder="$t('punishmentTransaction.placeholder.proposed_by')"
              v-model="punishmentTransaction.proposed_by_id"
              id="proposed_by_id"
              :hasError="!!errors.proposed_by_id"
              required
            />
          </field>
        </div>

        <div class="form-col">
          <field
            :label="$t('punishmentTransaction.pic1')"
            class="w-full md:w-2/2 px-3 mb-6 md:mb-0"
            :hasError="errors.pic1_id"
          >
            <control
              :options="employeeList"
              :placeholder="$t('punishmentTransaction.placeholder.pic1')"
              v-model="punishmentTransaction.pic1_id"
              id="pic1_id"
              :hasError="!!errors.pic1_id"
              required
            />
          </field>
        </div>

        <div class="form-col">
          <field
            :label="$t('punishmentTransaction.pic2')"
            class="w-full md:w-2/2 px-3 mb-6 md:mb-0"
            :hasError="errors.pic2_id"
          >
            <control
              :options="employeeList"
              :placeholder="$t('punishmentTransaction.placeholder.pic1')"
              v-model="punishmentTransaction.pic2_id"
              id="pic2_id"
              :hasError="!!errors.pic2_id"
            />
          </field>
        </div>

        <div class="form-col">
          <field
            :label="$t('punishmentTransaction.witness1')"
            class="w-full md:w-2/2 px-3 mb-6 md:mb-0"
            :hasError="errors.witness1_id"
            required
          >
            <control
              :options="employeeList"
              :placeholder="$t('punishmentTransaction.placeholder.witness1')"
              v-model="punishmentTransaction.witness1_id"
              id="witness1_id"
              :hasError="!!errors.witness1_id"
            />
          </field>
        </div>

        <div class="form-col">
          <field
            :label="$t('punishmentTransaction.witness2')"
            class="w-full md:w-2/2 px-3 mb-6 md:mb-0"
            :hasError="errors.witness2_id"
          >
            <control
              :options="employeeList"
              :placeholder="$t('punishmentTransaction.placeholder.witness2')"
              v-model="punishmentTransaction.witness2_id"
              id="witness2_id"
              :hasError="!!errors.witness2_id"
            />
          </field>
        </div>

        <div class="form-col" v-show="showDecree">
          <field
            :label="$t('punishmentTransaction.decree_no')"
            class="w-full md:w-2/2 px-3 mb-6 md:mb-0"
            :hasError="errors.decree_no"
          >
            <control
              type="text"
              :placeholder="$t('punishmentTransaction.placeholder.decree_no')"
              v-model="punishmentTransaction.decree_no"
              :hasError="!!errors.decree_no"
              id="decree_no"
            />
          </field>
        </div>

        <div class="form-col" v-show="showDecree">
          <field
            :label="$t('punishmentTransaction.file_name')"
            class="w-full md:w-2/2 px-3 mb-6 md:mb-0"
            help="* support only pdf format"
            :hasError="errors.file_name"
          >
            <input
              type="file"
              accept="application/pdf"
              v-on:change="onFileChange"
              class="form-control-file"
              id="my-file"
            />
          </field>
        </div>
      </div>

      <!-- Preview Section -->
      <div class="preview-content" v-show="showDecree">
        <div class="outer-prev">
          <center>
            <h2 v-if="!fileData && !previewFile">No Preview</h2>
            <h2 v-else>File Preview</h2>
          </center>

          <vue-pdf-embed
            v-if="fileData || previewFile"
            :source="fileData.file || previewFile"
            style="width: 100%; height: 100%; min-height: 500px"
          />
        </div>
      </div>

      <div
        class="buttons-submit transition-colors duration-1000"
        :class="darkMode ? 'bg-darkmode-base' : 'bg-gray-100'"
      >
        <jb-buttons class="buttons-action-submit">
          <jb-button
            type="submit"
            color="info"
            :icon="mdiCheckBold"
            :label="$t('finance.button.btnSubmit')"
            class="form-submit-btn"
          />
          <jb-button
            type="button"
            color="info"
            outline
            :label="$t('finance.button.btnReset')"
            class="form-noicon-btn btn-reset"
            @click="reset()"
          />
        </jb-buttons>
      </div>
    </div>
  </form>
  <!-- Loading -->
  <div class="vld-parent">
    <loading
      v-model:active="isLoading"
      :is-full-page="true"
      :height="128"
      :width="128"
    />
  </div>
</template>
<script>
/* eslint-disable */
import {
  ref,
  reactive,
  onMounted,
  onBeforeMount,
  watch,
  watchEffect,
  defineExpose,
} from "vue";
import axios from "axios";
import { mdiBallot, mdiCheckBold } from "@mdi/js";
import Control from "@/components/Control";
//   import CheckRadioPicker from '@/components/CheckRadioPicker'
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import JbButton from "@/components/JbButton";
import JbButtons from "@/components/JbButtons";
import Field from "@/components/Field";
import { useToast } from "vue-toastification";
import "@vuepic/vue-datepicker/dist/main.css";
import Loading from "vue-loading-overlay";
import Datepicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main\.css";
import "vue-loading-overlay/dist/vue-loading.css";
import VuePdfEmbed from "vue-pdf-embed";
// import { Year } from '@syncfusion/ej2-vue-schedule'
export default {
  name: "ClassForm",
  components: {
    Field,
    Control,
    Loading,
    Datepicker,
    //   CheckRadioPicker,
    JbButton,
    JbButtons,
    VuePdfEmbed,
  },
  props: {
    showEdit: { Boolean },

    propClass: {
      type: Object,
      default: () => ({ empty: true }),
    },
    propDepartment: {
      type: Object,
      default: () => ({ empty: true }),
    },
    propYear: {
      type: Object,
      default: () => ({ empty: true }),
    },
    propLevel: {
      type: Object,
      default: () => ({ empty: true }),
    },
    fileData: {
      type: Object,
    },
  },
  data: function () {
    return {};
  },
  emits: ["close-modal", "submit", "reset-modal"],
  setup(props, { emit }) {
    const titleStack = ref(["Admin", "Forms"]);

    const isLoading = ref(false);

    const toast = useToast();

    const router = useRouter();

    const errors = ref([]);

    const str = useStore();
    const userlogin = localStorage.getItem("name");

    const employeeList = ref();
    const violationList = ref();
    const schoolList = ref();
    const branchList = ref();
    const violationConsequenciesList = ref();
    const violationConsequenciesListFilter = ref();
    const previewFile = ref(null); // For PDF preview
    const showExpiredDate = ref(false);
    const image = ref({ name: "", size: 0 });
    const MaxUploadLimit = ref(0);
    const showDecree = ref(false);
    function createEmptyPunishmentTransaction() {
      return {
        id: "",
        transaction_date: "",
        number: "",
        employee_name: "",
        employee_id: "",
        violation_id: "",
        punishment_id: "",
        punishment_type_code: "",
        is_active: "",
        need_decree: "",
        active_expire_date: "",
        violation_description: "",
        punishment_description: "",
        school_id: "",
        branch_id: "",
        decree_no: "",
        file: null,
        file_url: "",
        remarks: "",
        expired_date: "",
        proposed_by_id: "",
        pic1_id: "",
        pic2_id: "",
        witness1_id: "",
        witness2_id: "",
        created_by: "",
        updated_by: "",
      };
    }

    const punishmentTransaction = reactive(createEmptyPunishmentTransaction());

    const reset = () => {
      Object.assign(punishmentTransaction, createEmptyPunishmentTransaction());
      punishmentTransaction.file = null;
      punishmentTransaction.file_url = "";
      image.value = { name: "", size: 0 };
      if (previewFile.value) {
        URL.revokeObjectURL(previewFile.value);
        previewFile.value = null;
      }
      errors.value = {};
      const fileInput = document.getElementById("my-file");
      if (fileInput) fileInput.value = "";
      emit("reset-modal");
    };

    const store = async () => {
      isLoading.value = true;
      const url = props.showEdit
        ? "/punishment-transaction/" + punishmentTransaction.id
        : "/punishment-transaction";
      const method = props.showEdit ? "PUT" : "POST";
      if (method === "POST") {
        punishmentTransaction.created_by = userlogin;
      } else {
        punishmentTransaction.updated_by = userlogin;
      }

      const jsonData = JSON.stringify(punishmentTransaction);
      const configHeaders = {
        "content-type": "application/json",
        Accept: "application/json",
      };

      await axios({
        method,
        url,
        data: jsonData,
        headers: configHeaders,
      })
        .then((response) => {
          if (response.data.success) {
            emit("reset-modal");
            emit("close-modal");
            toast.success(response.data.message);
          } else {
            errors.value = response.data.messages;
            toast.error(response.data.messages);
          }
          isLoading.value = false;
          reset();
        })
        .catch((error) => {
          if (error.response) {
            console.log(error);
            toast.error(error.response.data.message);
            console.log(JSON.stringify(error.request));
          } else if (error.message) {
            console.log(error.message);
            toast.error(error.message);
            console.log(JSON.stringify(error.message));
          }
          isLoading.value = false;
        });
    };

    const getSchool = async () => {
      isLoading.value = true;
      await axios
        .get("school")
        .then((response) => {
          schoolList.value = response.data.data;
          // filter.department_id = departmentList.value[0].id
          isLoading.value = false;
        })
        .catch((error) => {
          toast.error(error.response.data, { timeout: 5000 });
          console.log(error);
          isLoading.value = false;
        });
    };

    const getBranch = async () => {
      isLoading.value = true;
      await axios
        .get("branch")
        .then((response) => {
          branchList.value = response.data.data;
          // filter.department_id = departmentList.value[0].id
          isLoading.value = false;
        })
        .catch((error) => {
          toast.error(error.response.data, { timeout: 5000 });
          console.log(error);
          isLoading.value = false;
        });
    };

    const getEmployee = async () => {
      isLoading.value = true;
      const userId = localStorage.getItem("user_id");
      const branchId = localStorage.getItem("branch_id");
      const params = {
        user_id: userId,
        branch_id: branchId,
      };
      await axios
        .get("employee", { params })
        .then((response) => {
          employeeList.value = response.data.data;
          isLoading.value = false;
        })
        .catch((error) => {
          toast.error(error.response.data, { timeout: 5000 });
          console.log(error);
          isLoading.value = false;
        });
    };

    const getUploadLimitPunishmentTransaction = async () => {
      await axios
        .get("/upload-limit-punishment-transaction")
        .then((res) => {
          MaxUploadLimit.value = res.data.data;
        })
        .catch((error) => {
          console.error(error);
        });
    };

    const getViolation = async () => {
      isLoading.value = true;
      await axios
        .get("violation")
        .then((response) => {
          violationList.value = response.data.data;
          isLoading.value = false;
        })
        .catch((error) => {
          toast.error(error.response.data, { timeout: 5000 });
          console.log(error);
          isLoading.value = false;
        });
    };

    const getViolationConsequencies = async () => {
      isLoading.value = true;
      const params = {
        violation_id: punishmentTransaction.violation_id,
        employee_id: punishmentTransaction.employee_id,
      };
      await axios
        .get("/violation-consequencies", {
          params: params,
        })
        .then((response) => {
          violationConsequenciesList.value = response.data.data
            .map((emp) => ({
              id: emp.punishment_id,
              name: emp.label,
              punishment_id: emp.punishment_id,
              violation_id: emp.violation_id,
              expired_in: emp.expired_in,
              active_expire_date: emp.active_expire_date,
              need_decree: emp.need_decree,
              sequence_no: emp.sequence_no,
            }))
            .sort((a, b) => a.sequence_no - b.sequence_no);
          isLoading.value = false;
        })
        .catch((error) => {
          toast.error(error.response.data, { timeout: 5000 });
          console.log(error);
          isLoading.value = false;
        });
    };

    const violationConsequenciesListFilterx = ref();

    const handleDateChange = (punishmentTransaction, event) => {
      // getViolationConsequencies
      if (
        Array.isArray(violationConsequenciesList.value) &&
        punishmentTransaction.transaction_date
      ) {
        const result = violationConsequenciesList.value.find((item) => {
          return item.punishment_id === punishmentTransaction.punishment_id;
        });
        if (result.active_expire_date) {
          violationConsequenciesListFilterx.value = result || {};

          const expiredIn =
            violationConsequenciesListFilterx.value.expired_in || 0;

          const selectedDate = new Date(punishmentTransaction.transaction_date);
          // Add 1 month
          selectedDate.setMonth(selectedDate.getMonth() + expiredIn);

          // Format back to YYYY-MM-DD if needed
          const yyyy = selectedDate.getFullYear();
          const mm = String(selectedDate.getMonth() + 1).padStart(2, "0"); // Months are 0-based
          const dd = String(selectedDate.getDate()).padStart(2, "0");

          const newDateStr = `${yyyy}-${mm}-${dd}`;
          punishmentTransaction.expired_date = newDateStr;
          showExpiredDate.value = true;
        } else {
          punishmentTransaction.expired_date = null;
          showExpiredDate.value = false;
        }
      }
    };

    const onFileChange = async (event) => {
      const file = event.target.files[0];
      if (file) {
        const maxLimitMB = parseInt(MaxUploadLimit.value ?? "0");
        if (maxLimitMB > 0 && file.size > maxLimitMB * 1024 * 1024) {
          toast.error(`File too big ( > ${maxLimitMB}MB)`);
          event.target.value = "";
          previewFile.value = null;
          image.value = { name: "", size: 0 };
          punishmentTransaction.file = null;
          punishmentTransaction.file_name = "";
          punishmentTransaction.file_url = "";
          return;
        }

        if (file.type !== "application/pdf") {
          toast.error("Only PDF files are allowed");
          event.target.value = "";
          previewFile.value = null;
          image.value = { name: "", size: 0 };
          punishmentTransaction.file = null;
          punishmentTransaction.file_name = "";
          punishmentTransaction.file_url = "";
          return;
        }

        if (previewFile.value) {
          URL.revokeObjectURL(previewFile.value);
        }
        previewFile.value = URL.createObjectURL(file);

        // Read file as base64
        const reader = new FileReader();
        reader.onload = (e) => {
          punishmentTransaction.file = e.target.result; // Store base64 string
          image.value = {
            name: file.name,
            size: file.size,
          };
        };
        reader.onerror = () => {
          toast.error("Failed to read file");
          previewFile.value = null;
          image.value = { name: "", size: 0 };
          punishmentTransaction.file = "";
          punishmentTransaction.file_name = "";
          punishmentTransaction.file_url = "";
        };
        reader.readAsDataURL(file);
      } else {
        if (previewFile.value) {
          URL.revokeObjectURL(previewFile.value);
        }
        previewFile.value = null;
        image.value = { name: "", size: 0 };
        punishmentTransaction.file = "";
        punishmentTransaction.file_name = "";
        punishmentTransaction.file_url = "";
        event.target.value = "";
      }
    };

    onBeforeMount(() => {});
    onMounted(() => {
      // academicyear.value =toRefs(props, 'propClass')
      getEmployee();
      getViolation();
      getSchool();
      getBranch();
      getUploadLimitPunishmentTransaction();
      getViolationConsequencies();
    });

    watch(
      [
        () => punishmentTransaction.violation_id,
        () => punishmentTransaction.employee_id,
      ],
      ([newViolationId, newEmployeeId], [oldViolationId, oldEmployeeId]) => {
        if (newViolationId && newEmployeeId) {
          violationConsequenciesListFilter.value =
            violationConsequenciesList.value.filter((item) => {
              return item.violation_id === newViolationId;
            });
        }
      }
    );

    watch(
      () => punishmentTransaction.punishment_id,
      (newVal, oldVal) => {
        const result = violationConsequenciesList.value.find((item) => {
          return item.punishment_id === newVal;
        });
        if (result && result.need_decree) {
          showDecree.value = true;
        }
      }
    );

    watchEffect(() => {
      const newObject = props.propClass;
      Object.assign(punishmentTransaction, newObject);
      if (punishmentTransaction.active_expire_date) {
        showExpiredDate.value = true;
      }

      if (props.showEdit && newObject.file_url) {
        if (!previewFile.value || previewFile.value !== newObject.file_url) {
          previewFile.value = newObject.file_url;
          image.value = {
            name: newObject.file_name || "Existing File",
            size: newObject.file_size || 0,
          };
        }
      }
    });
    defineExpose({ reset });
    return {
      isLoading,
      titleStack,
      employeeList,
      violationList,
      schoolList,
      branchList,
      violationConsequenciesList,
      mdiBallot,
      mdiCheckBold,
      router,
      getEmployee,
      getViolation,
      getSchool,
      getBranch,
      getViolationConsequencies,
      punishmentTransaction,
      store,
      toast,
      userlogin,
      errors,
      reset,
      str,
      violationConsequenciesListFilter,
      onFileChange,
      handleDateChange,
      MaxUploadLimit,
      previewFile,
      showExpiredDate,
      showDecree,
    };
  },
  methods: {
    clearForm() {
      this.punishmentTransaction = reactive({
        id: "",
        transaction_date: "",
        number: "",
        employee_name: "",
        violation_description: "",
        punishment_description: "",
        school_id: "",
        branch_id: "",
        decree_no: "",
        file: null,
        file_url: "",
        remarks: "",
        expired_date: "",
        proposed_by_id: "",
        pic1_id: null,
        pic2_id: null,
        witness1_id: "",
        witness2_id: null,
        created_by: "",
      });
      this.image = { name: "", size: 0 };
      this.previewFile = null;
    },
    onChange: function (violationConsequncies_id, event) {
      if (event.target.value) {
        violationConsequncies_id = event.target.value;
      }
    },
  },
  // created () {
  //   this.levelListFilter = this.levelList
  //   this.academicYearListFilter = this.academicYearList
  // }
};
</script>

<style lang="scss" scoped>
.modal-content-container {
  display: flex;
  // flex-direction: column;
  // gap: 20px;
  // max-width: 1200px; /* Match parent modal width */
  width: 100%;
  padding: 20px;
  box-sizing: border-box;
  // min-height: 600px; /* Ensure minimum height for content */

  .form-content {
    width: 100%;

    .form-content-inner {
      width: 100%;
      height: auto;
      display: flex;
      flex-direction: column;
      gap: 20px;

      .form-content-list {
        width: 100%;

        .file-meta {
          margin-top: 10px;
          padding: 10px;
          background-color: #f1f5f9;
          border-radius: 4px;
          width: 100%;
          text-align: left;

          p {
            margin: 5px 0;
            color: #1f2937;
          }
        }
      }

      .preview-content {
        width: 100%;

        .outer-prev {
          .preview-title {
            font-size: 1.25rem;
            font-weight: 600;
            margin-bottom: 12px;
            color: #1f2937; /* Dark text for light theme */
            width: 100%;
            text-align: center;
          }
        }
      }
    }
  }

  .no-preview {
    color: #6b7280; /* Muted text for light theme */
    font-size: 1rem;
    text-align: center;
    width: 100%;
  }

  @media (min-width: 1024px) {
    .form-content {
      .form-content-inner {
        flex-direction: row;
      }
    }
  }
}
</style>
